(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("react-jsx-parser", ["react"], factory);
	else if(typeof exports === 'object')
		exports["react-jsx-parser"] = factory(require("react"));
	else
		root["react-jsx-parser"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 